import {handleActions} from 'redux-actions';
import {closeWindow,  openWindow} from '../actions/windowsActions';
import {WINDOW_STATES} from '../utils/windowsUtil';

export const windows = handleActions(
    {
        [openWindow]: (state, action) => {
            const w = {
                ...state[action.payload.portletId],
            };

            w[action.payload.name] = {
                ...action.payload,
                state: WINDOW_STATES.VISIBLE,
            };

            return {
                ...state,
                [action.payload.portletId]: w,
            };
        },
        [closeWindow]: (state, action) => {
            const w = {
                ...state[action.payload.portletId],
            };

            w[action.payload.name] = {
                state: WINDOW_STATES.HIDDEN,
            };

            return {
                ...state,
                [action.payload.portletId]: w,
            };
        },
    },
    {}
);
